import { LiquidEngineService } from '../../services/liquidEngineService';
import { ContentType } from '../../content/Content';
import { PropertiesInterface } from '../Property';
import { BlockInstanceTemplatedPropertiesExtractor } from '../block/blockInstanceTemplatedPropertiesExtractor';
import { BlockRegistry } from '../block/blockRegistry';

export class ContentTemplatedPropertiesExtractor {
  constructor(
    protected content: ContentType,
    protected blockRegistry: BlockRegistry,
    protected liquidEngineService = new LiquidEngineService()
  ) {}

  async extractPropertiesInterface(): Promise<PropertiesInterface> {
    const blockInstancePropertyTypeExtractor: BlockInstanceTemplatedPropertiesExtractor =
      new BlockInstanceTemplatedPropertiesExtractor(
        this.content.block,
        this.blockRegistry
      );
    const blockProperties =
      blockInstancePropertyTypeExtractor.extractPropertiesInterface();

    const contentNameTemplateVariableName =
      this.liquidEngineService.getTemplateVariableName(this.content.name);
    const contentNameProperties = {};

    if (contentNameTemplateVariableName) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      contentNameProperties[contentNameTemplateVariableName] = {
        type: 'String',
      };
    }

    const contentDescriptionTemplateVariableName =
      this.liquidEngineService.getTemplateVariableName(
        this.content.description
      );
    const contentDescriptionProperties = {};

    if (contentDescriptionTemplateVariableName) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      contentDescriptionProperties[contentDescriptionTemplateVariableName] = {
        type: 'String',
      };
    }

    return this.mergeProperties(
      contentNameProperties,
      contentDescriptionProperties,
      blockProperties
    );
  }

  mergeProperties(
    nameProperties: any,
    descriptionProperties: any,
    blockProperties: any
  ): PropertiesInterface {
    const allPropertyNames = Object.keys(nameProperties)
      .concat(Object.keys(descriptionProperties))
      .concat(Object.keys(blockProperties));
    const uniquePropertyNames = new Set(allPropertyNames);

    if (uniquePropertyNames.size !== allPropertyNames.length) {
      throw new Error(
        `There is more than one property that shares the same name. Please make sure that property names are unique.`
      );
    }

    return Object.assign(
      nameProperties,
      descriptionProperties,
      blockProperties
    );
  }
}
